import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d1aecd6a")

_pushScopeId("data-v-d1aecd6a")
const _hoisted_1 = { class: "dropdown-item__content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.isSelect)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: ["dropdown-item", { selected: _ctx.selected }]
      }, [
        _createVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ], 2))
    : _createCommentVNode("", true)
})